import { Component } from '@angular/core';

@Component({
  selector: 'app-priacy',
  templateUrl: './privacy.component.html',
  styleUrl: './legal.component.css',
  standalone: true,
})
export class PrivacyComponent {
  content = {
    companyName: "DIGI America",
    companyFullName: "DIGI America, Inc",
    country: "The United States of America"
  }
}
